/**
 * Stepper rendering each rollout stage; current highlighted, completed checked.
 */
import { ArrowRight, CheckCircle2, Circle } from "lucide-react";
import type { PortalRolloutStage } from "@/lib/portal-api";

export function StageStepper({ stages }: { stages: PortalRolloutStage[] }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {stages.map((stage, i) => (
        <div key={stage.policy} className="flex items-center gap-1.5">
          <span
            className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-[12px] font-medium ${
              stage.is_current
                ? "border-[var(--color-primary)] bg-[var(--color-primary)]/10 text-foreground"
                : stage.is_completed
                  ? "border-border bg-secondary text-muted-foreground"
                  : "border-border text-muted-foreground"
            }`}
          >
            {stage.is_completed ? (
              <CheckCircle2 className="h-3.5 w-3.5 text-[var(--v2-good)]" />
            ) : (
              <Circle
                className={`h-3.5 w-3.5 ${stage.is_current ? "text-[var(--color-primary)]" : ""}`}
              />
            )}
            p={stage.policy}
          </span>
          {i < stages.length - 1 && (
            <ArrowRight className="h-3.5 w-3.5 shrink-0 text-[var(--v2-fg-subtle)]" />
          )}
        </div>
      ))}
    </div>
  );
}
